var UnderstandingReportName;
(function (UnderstandingReportName) {
    UnderstandingReportName["HOLDINGS"] = "Holding";
    UnderstandingReportName["POSITION"] = "Position";
    UnderstandingReportName["PNL"] = "PNL";
    UnderstandingReportName["TAX"] = "Tax";
})(UnderstandingReportName || (UnderstandingReportName = {}));
export var UnderstandingReportType;
(function (UnderstandingReportType) {
    UnderstandingReportType["PNL_REPORT_REALISED"] = "PNL_REPORT_REALISED";
    UnderstandingReportType["PNL_REPORT_UNREALISED"] = "PNL_REPORT_UNREALISED";
    UnderstandingReportType["SUMMARY_FIELD"] = "SummaryField";
})(UnderstandingReportType || (UnderstandingReportType = {}));
export default UnderstandingReportName;
